<template>
  <v-container class="fill-height" fluid>
    <Chat />
  </v-container>
</template>
<script>
import Chat from '@/components/Chat/Chat'
export default {
    components: {
        Chat
    }
}
</script>